module.exports = __webpack_public_path__ + "static/media/jo.51302798.svg";